const present = (text: string): boolean =>
  !!text && !["", "-"].includes(text.trim());

export const firstPresent = (list: Array<string>): string =>
  list.find(present) || "";

export const allPresent = (list: Array<string>): string[] =>
  list.filter(present);

export const ensureArray = <T>(value: unknown): T[] => {
  return Array.isArray(value) ? (value as T[]) : [];
};
